module.exports = __webpack_public_path__ + "static/media/icon_monotributista.2ce9cc96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_monotributista.svg
// module id = 626
// module chunks = 0